import React from 'react';

import { FilterOperatorEnum, GroupTypeEnum } from '@/types/schema';

import { ConditionalFieldsMapping, FilterInputsD1 } from '../../types';
import AddedCondition, { AddedConditionProps } from '../AddedCondition';
import { FilterItemOverrides, FilterItemProps } from '../FilterItem';

interface AddedConditionGroupsProps {
  filters: Array<FilterInputsD1 & { tempId: string }>;
  onGroupChange: (item: FilterInputsD1, index: number) => void;
  conditionOperator: FilterOperatorEnum;
  onConditionOperatorChange: (val: FilterOperatorEnum) => void;
  error?: boolean;
  onGroupDelete: (index: number) => void;
  onGroupDuplicate: (index: number) => void;
  type: GroupTypeEnum;
  filterItemOverrides?: FilterItemOverrides;
  RenderFilterItem?: (params: FilterItemProps) => React.JSX.Element;
  disabled?: boolean;
  classes?: AddedConditionProps['classes'];
  fieldsMapping?: ConditionalFieldsMapping[];
  showPlaceholderIcon?: boolean;
  order?: number;
}

function AddedConditionGroups(props: AddedConditionGroupsProps) {
  const { filters, ...rest } = props;

  return (
    <>
      {filters.map((filter, index) => (
        <AddedCondition key={filter.tempId} filter={filter} index={index} {...rest} />
      ))}
    </>
  );
}

export default AddedConditionGroups;
